import React, { useEffect, useLayoutEffect, useRef, useState } from "react";
import { IoMdClose, IoMdExpand } from "react-icons/io";

function CardPopup({ card, onClose, returnFocus }) {
  const dialog = useRef(null);
  useEffect(() => {
    const element = dialog.current;
    const previousFocus = returnFocus || document.activeElement;
    const overflow = document.body.style.overflow;
    element.showModal();
    element.querySelector("button").focus({ preventScroll: true });
    document.body.style.overflow = "hidden";
    return () => {
      element.close();
      document.body.style.overflow = overflow;
      if (previousFocus?.isConnected) previousFocus.focus({ preventScroll: true });
    };
  }, []);
  return <dialog ref={dialog} className="our-role-card-dialog" aria-labelledby="our-role-card-title"
    onCancel={event => { event.preventDefault(); onClose(); }} onClose={onClose}
    onClick={event => { if (event.target === event.currentTarget) onClose(); }}>
    <div className="popup-container our-role-managed-popup">
      <button type="button" className="close-btn" aria-label="Close expanded card" onClick={onClose}><IoMdClose aria-hidden="true" /></button>
      <div className="popup-section">
        <div className="popup-left-container">
          <h2 id="our-role-card-title" className="popup-font40">{card.title}</h2>
          {card.summary && <p className="popup-font20">{card.summary}</p>}
        </div>
        <div className="popup-right-container">
          {card.image && <img src={card.image} alt="" className="popup-img" decoding="async" />}
          <div className="popup-content">
            {card.details && <h3 className="popup-font18">SPOTLIGHT</h3>}
            {(card.details || "").split(/\n\s*\n/).filter(Boolean).map((paragraph, index) => <p key={index} className="popup-font16">{paragraph}</p>)}
          </div>
        </div>
      </div>
    </div>
  </dialog>;
}

export default function ManagedCards({ cards }) {
  const [selected, setSelected] = useState(null);
  const grid = useRef(null);
  const opener = useRef(null);
  useLayoutEffect(() => {
    if (!grid.current) return;
    const element = grid.current;
    // Three bounded measurements, only when text/font/available width changes.
    // Equal card heights can grow beyond 420px instead of clipping long titles.
    const titles = [...element.querySelectorAll('.card-content h3')];
    const measure = () => element.style.setProperty('--role-card-height', `${Math.ceil(Math.max(420, ...titles.map(title => title.getBoundingClientRect().height + 288)))}px`);
    const observer = new ResizeObserver(measure);
    titles.forEach(title => observer.observe(title));
    measure();
    return () => observer.disconnect();
  }, [cards]);
  if (!cards.length) return <p className="our-role-empty" role="status">No published stories in this area yet.</p>;
  return <>
    <div ref={grid} className="our-role-managed-grid">
      {cards.map(card => <article className="card" key={card.id}>
        {card.image ? <img src={card.image} className="edu-img" alt="" loading="lazy" decoding="async" /> : <div className="edu-img" aria-hidden="true" />}
        <div className="card-content">
          <h3>{card.title}</h3>
          <button type="button" className="expand-sec" aria-haspopup="dialog" aria-label={`Expand to learn more: ${card.title}`} onClick={event => { opener.current = event.currentTarget; setSelected(card); }}>
            <span>EXPAND TO LEARN MORE</span><IoMdExpand aria-hidden="true" />
          </button>
        </div>
      </article>)}
    </div>
    {selected && <CardPopup card={selected} returnFocus={opener.current} onClose={() => setSelected(null)} />}
  </>;
}
